<template>
  <confirmation-dialog
    name="tag-edit-confirmation-dialog"
    manual-hide
    :disabled="loading"
    @confirmed="onConfirm"
    @canceled="$emit('canceled')"
  >
    <template v-slot:title>
      <v-progress-linear
        v-if="loading"
        indeterminate
        absolute
        top
        color="primary"
      />
      Редактирование
    </template>

    <template v-slot:text>
      <template v-if="!tag">
        Загрузка актуальных данных...
      </template>

      <template v-else>
        <tag-touched-entities :items="tag.entities" />

        Вы действительно хотите изменить тег?
      </template>
    </template>
  </confirmation-dialog>
</template>

<script>

import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import ConfirmationDialog from '@/components/dialogs/confirmations/ConfirmationDialog.vue';
import TagTouchedEntities from '@/views/references/tags/components/TagTouchedEntities.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'tag-edit-confirmation',

  components: { ConfirmationDialog, TagTouchedEntities },

  mixins: [DialogBusMixin],

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState('tags', { tag: 'single' }),
  },

  watch: {
    async dialog(value) {
      if (!value) {
        this.$dialog.hide('tag-edit-confirmation-dialog');

        return;
      }

      this.$dialog.show('tag-edit-confirmation-dialog');
    },
  },

  methods: {
    ...mapActions('tags', ['removeSingle', 'getItem']),

    async beforeOpen({ item }) {
      this.loading = true;

      await this.removeSingle();
      // eslint-disable-next-line no-return-assign
      this.getItem(item.id).then(() => this.loading = false);
    },

    onConfirm() {
      this.loading = true;

      this.$emit('confirmed', this.params.item);
    },
  },
};

</script>
